/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ReservationType;
(function (ReservationType) {
    ReservationType["Customer"] = "Customer";
    ReservationType["Service"] = "Service";
})(ReservationType || (ReservationType = {}));
export function ReservationTypeFromJSON(json) {
    return ReservationTypeFromJSONTyped(json, false);
}
export function ReservationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ReservationTypeToJSON(value) {
    return value;
}
